define(function (require) {
	//FORMAT_TAGS is an array of tags being added on the captions/text in a field.
	const FORMAT_TAGS = ['__html__', '__horizontalAlign__', '__fullWidthField__'];
	let S4 = function () {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	};
	return {
		cleanFormatTags: function(text){
			if (!text) {
				return text; 
			}
		
			FORMAT_TAGS.forEach(tag => {
				if (text.toLowerCase().includes(tag.toLowerCase())) {
					const regEx = new RegExp(tag, 'gi');
					text = text.replace(regEx, '');
				}
			});
		
			return text.trim();
		},
		formatId: function (description, type) {
			var withHtmlStr = description.match("<span>(.*?)</span>");

			if (withHtmlStr != null)
				description = withHtmlStr[1];

			var combinedStr = description + ' ' + type;
			return combinedStr.replace(/[^a-zA-Z0-9 ]/g, "").split(/\s{1,}/g).join('_');
		},
		S4: function () {
			return S4();
		},
		generateId: function () {
			return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
		}
	}
});